import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { FullscreenAppCustomProps } from '@wppopen/core'
import { OsProvider } from '@wppopen/react'
import { StrictMode } from 'react'

import { App, AppWithOs } from 'app/App'
import { msalConfig } from 'auth/config'
import { ApiProviderAlphaZulu } from 'providers/ApiProviderAlphaZulu'
import { HostPlatformProvider } from 'providers/HostPlatformProvider'
import { HubApiProvider } from 'providers/HubApiProvider'
import { HubPlatformProvider } from 'providers/HubPlatformProvider'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

type RootProps = Partial<FullscreenAppCustomProps> & {
  msalInstance?: PublicClientApplication
  getToken?: () => Promise<string>
  props?: FullscreenAppCustomProps
}

const HubRoot = ({ instance, getToken }: { instance?: PublicClientApplication; getToken?: () => Promise<string> }) => {
  const msalInstance = instance ?? new PublicClientApplication(msalConfig)

  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <div id="mos-pg-bva" data-mos-pg-bva-portal="">
          <HubPlatformProvider>
            <HubApiProvider getToken={getToken}>
              <App />
            </HubApiProvider>
          </HubPlatformProvider>
        </div>
      </QueryClientProvider>
    </MsalProvider>
  )
}

export const Root = ({ msalInstance, getToken, props, ...spaProps }: RootProps) => {
  const osProps = props?.osContext ? props : spaProps.osContext ? (spaProps as FullscreenAppCustomProps) : undefined

  if (osProps) {
    return (
      <StrictMode>
        <OsProvider {...osProps}>
          <QueryClientProvider client={queryClient}>
            <div id="mos-pg-bva" data-mos-pg-bva-portal="">
              <HostPlatformProvider platform="wpp">
                <ApiProviderAlphaZulu>
                  <AppWithOs />
                </ApiProviderAlphaZulu>
              </HostPlatformProvider>
            </div>
          </QueryClientProvider>
        </OsProvider>
      </StrictMode>
    )
  }

  return (
    <StrictMode>
      <HubRoot instance={msalInstance} getToken={getToken} />
    </StrictMode>
  )
}
